import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.0_@types+node@22.10.2_db0@0.3.2_mysql2@3.14.1__ioredis@_13e693e5b5b6c0091ba1a4e8a051cbe8/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}